'use strict';

function ChangeStatusController(
  $scope,
  $mdDialog,
  assignationsCount: number,
  suggestedDate: Date,
  status: string,
  allAssignationsCount: number
) {
  $scope.assignationsCount = assignationsCount;
  $scope.statusDate = suggestedDate;
  const remaining = assignationsCount < allAssignationsCount ?
    `(restan en el listado: ${allAssignationsCount - assignationsCount})` : '';

  $scope.getTitle = function() {
    if (status === 'reassign') {
      return `Reasignar ${assignationsCount} asignaciones ${remaining}`;
    }

    return [
      'Marcar como',
      ...(status === 'notDone' ? ['NO'] : []),
      `hechas ${assignationsCount} asignaciones`,
      remaining
    ].join(' ');
  };

  $scope.save = function() {
    $mdDialog.hide({
      statusDate: $scope.statusDate,
      statusComments: $scope.statusComments
    });
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}
ChangeStatusController.$inject = [
  '$scope',
  '$mdDialog',
  'assignationsCount',
  'suggestedDate',
  'status',
  'allAssignationsCount'
];

export default ChangeStatusController;
